// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"collapsible-block"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M4 3L6 5L8 3H4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M19 5L17 3L15 5L19 5Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M4 3L6 5L8 3H4Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M19 5L17 3L15 5L19 5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 11H13M3 16H21M3 21H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-collapsible-block')
export default class CollapsibleBlockIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'collapsible-block',
    }
  }
}
